/**
 * Shared utilities for contact cadences tab and its sub-components.
 */

import { formatSlashDate, formatShortDate as formatShortDateUtil } from '../../utils/cadence-data-mappers';

// ---------------------------------------------------------------------------
// Column definitions for Manage Columns
// ---------------------------------------------------------------------------

export const CURRENT_COLUMNS = [
  { field: 'cadenceName', label: 'Cadence Name', alwaysVisible: true },
  { field: 'type', label: 'Type' },
  { field: 'status', label: 'Status' },
  { field: 'startDate', label: 'Start Date' },
  { field: 'daysActive', label: 'Days Active' },
  { field: 'nextAction', label: 'Next Action' },
  { field: 'goal', label: 'Goal' },
];

export const HISTORY_COLUMNS = [
  { field: 'cadenceName', label: 'Cadence Name', alwaysVisible: true },
  { field: 'type', label: 'Type' },
  { field: 'status', label: 'Status' },
  { field: 'startDate', label: 'Start Date' },
  { field: 'endDate', label: 'End Date' },
  { field: 'goal', label: 'Goal' },
];

// ---------------------------------------------------------------------------
// Column visibility persistence
// ---------------------------------------------------------------------------

const CONTACT_COL_STORAGE_KEY = 'contact-cadences-columns';

export const loadContactColVisibility = (mode) => {
  try {
    const stored = localStorage.getItem(`${CONTACT_COL_STORAGE_KEY}-${mode}`);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

export const saveContactColVisibility = (mode, vis) => {
  try {
    localStorage.setItem(`${CONTACT_COL_STORAGE_KEY}-${mode}`, JSON.stringify(vis));
  } catch {
    // ignore
  }
};

// ---------------------------------------------------------------------------
// Date/time formatters
// ---------------------------------------------------------------------------

export const formatDate = formatSlashDate;

export const formatShortDate = formatShortDateUtil;

export const computeDaysActive = (enrolledAt, endAt) => {
  if (!enrolledAt) return '\u2014';
  const normalized = /[zZ]|[+-]\d{2}:\d{2}$/.test(enrolledAt) ? enrolledAt : enrolledAt + 'Z';
  const start = new Date(normalized);
  const end = endAt ? new Date(/[zZ]|[+-]\d{2}:\d{2}$/.test(endAt) ? endAt : endAt + 'Z') : new Date();
  const days = Math.max(0, Math.floor((end - start) / (1000 * 60 * 60 * 24)));
  if (days === 0) return '< 1 day';
  return `${days} day${days !== 1 ? 's' : ''}`;
};

// ---------------------------------------------------------------------------
// Row helpers
// ---------------------------------------------------------------------------

export const getFirstName = (contact) => {
  if (contact.first_name) return contact.first_name;
  if (contact.name) return contact.name.split(' ')[0];
  return 'Contact';
};

export const getTypeBadge = (cadenceType) => {
  const t = (cadenceType || '').toLowerCase();
  if (t === 'bulk_message' || t === 'bulk') return { label: 'Bulk Email', className: 'is-bulk' };
  if (t === 'prospect_plan') return { label: 'Prospect Plan', className: 'is-prospect-plan' };
  return { label: 'Cadence', className: 'is-cadence' };
};

export const deriveRowStatus = (row) => row.displayStatus || 'n_a';

export const isCurrent = (row) => {
  const s = (row.status || '').toLowerCase();
  const isBulk = (row.cadenceType || '').toLowerCase() === 'bulk_message';

  if (isBulk) {
    const cadStatus = (row.cadenceStatus || '').toLowerCase();
    if (cadStatus === 'scheduled' || cadStatus === 'draft') return true;
    if (cadStatus === 'active' || cadStatus === 'completed') return false;
    return s === 'active' || s === 'enrolled';
  }

  return s === 'active' || s === 'enrolled' || s === 'paused';
};
